// https://timdeschryver.dev/blog/flagged-enum-what-why-and-how
export enum AccountFeatures {
    Default = 0,
    TrackingDevice = 1 << 0, // Only enabled if we have a separate tracking device
    Can = 1 << 1,
    Camera = 1 << 2,
    Breathalock = 1 << 3,
    Tacho = 1 << 4,
    Messaging = 1 << 5,
    Temperature = 1 << 6,
    Tyres = 1 << 7,
    FaultCodes = 1 << 8,
    GPS = 1 << 9,
    TMS = 1 << 10,
    Reefer = 1 << 11,
    ContextualSpeeding = 1 << 12,
    Maintenance = 1 << 13,
    ReportBuilder = 1 << 14,
    DriverDashboard = 1 << 15,
    SSO = 1 << 16,
    Ebpms = 1 << 17,
}
